import api from 'api';
import axios from 'axios';
import qs from 'qs';

const APP_API = process.env.REACT_APP_API_URL;
const EMAIL_API = process.env.REACT_APP_PHP_API_URL;

/**
 * Approved User
 */
interface ApprovedUserParams {
	userName: string;
	userEmail: string;
}

const sendEmailApprovedUser = async (data: ApprovedUserParams) => {
	const response = await axios({
		method: 'post',
		url: EMAIL_API + api.EMAIL.APPROVED_USER_EMAIL,
		data: qs.stringify(data)
	});

	return response.data;
};

/**
 * Ticket
 */

const sendEmailTicket = async (data: FormData) => {
	const response = await axios({
		method: 'post',
		url: EMAIL_API + api.EMAIL.SEND_TICKET_EMAIL,
		data
		// params: {data: {...data, url: APP_API}}
	});

	return response.data;
};

interface SendEmailTicketCancelParams {
	pnr: string;
	email: string;
}

const sendEmailTicketCancel = async (data: SendEmailTicketCancelParams) => {
	const response = await axios({
		method: 'get',
		url: EMAIL_API + api.EMAIL.SEND_BOOKING_CANCEL_EMAIL,
		params: {data: {...data, url: APP_API}}
	});

	return response.data;
};

interface SendEmailTicketRefundParams {
	pnr: string;
	email: string;
}

const sendEmailTicketRefund = async (data: SendEmailTicketRefundParams) => {
	const response = await axios({
		method: 'get',
		url: EMAIL_API + api.EMAIL.SEND_REFUND_TICKET_EMAIL,
		params: {data: {...data, url: APP_API}}
	});

	return response.data;
};

interface SendEmailBookingTicketParams {
	id: number;
	pnr: string;
	address: string;
	email: string;
}

const sendEmailBookingTicket = async (data: SendEmailBookingTicketParams) => {
	const response = await axios({
		method: 'get',
		url: EMAIL_API + api.EMAIL.SEND_BOOKING_TICKET_EMAIL,
		params: {data: {...data, url: APP_API}}
	});

	return response.data;
};

interface SendEmailIssueTicketParams {
	pnr: string;
	email: string;
}

const sendEmailIssueTicket = async (data: SendEmailIssueTicketParams) => {
	const response = await axios({
		method: 'get',
		url: EMAIL_API + api.EMAIL.SEND_ISSUE_TICKET_EMAIL,
		params: {data: {...data, url: APP_API}}
	});

	return response.data;
};

interface SendEmailBookingAddParams {
	pnr: string;
	email: string;
}

const sendEmailBookingAdd = async (data: SendEmailBookingAddParams) => {
	const response = await axios({
		method: 'get',
		url: EMAIL_API + api.EMAIL.SEND_BOOKING_ADD_EMAIL,
		params: {data: {...data, url: APP_API}}
	});

	return response.data;
};

/**
 * Invoice
 */

const sendEmailInvoice = async (data: FormData) => {
	const response = await axios({
		method: 'post',
		url: EMAIL_API + api.EMAIL.SEND_INVOICE_EMAIL,
		data
		// params: {data: {...data, url: APP_API}}
	});

	return response.data;
};

/**
 * Receipt
 */

const sendEmailReceipt = async (data: FormData) => {
	const response = await axios({
		method: 'post',
		url: EMAIL_API + api.EMAIL.SEND_RECEIPT_EMAIL,
		// params: {data: {...data, url: APP_API}}
		data
	});

	return response.data;
};

interface RegistrationConfirmParams {
	veryficationToken: string;
	userEmail: string;
	url: string;
}

const sendEmailRegistrationConfirm = async (data: RegistrationConfirmParams) => {
	const response = await axios({
		method: 'post',
		url: EMAIL_API + api.EMAIL.REGISTER_CONFIRM_EMAIL,
		data: qs.stringify(data)
	});

	return response.data;
};

interface ResetPasswordParams {
	veryficationToken: string;
	userEmail: string;
	url: string;
}

const sendEmailResetPassword = async (data: ResetPasswordParams) => {
	const response = await axios({
		method: 'post',
		url: EMAIL_API + api.EMAIL.RESET_PASSWORD_EMAIL,
		data: qs.stringify(data)
	});

	return response.data;
};

const verificateEmail = async (url: string, userId: string) => {
	const response = await axios({
		method: 'get',
		url: 'http://' + url + '&userId=' + userId
	});
	return response.data;
};

const service = {
	sendEmailApprovedUser,
	sendEmailTicket,
	sendEmailBookingTicket,
	sendEmailInvoice,
	sendEmailReceipt,
	sendEmailRegistrationConfirm,
	sendEmailResetPassword,
	verificateEmail,
	sendEmailTicketCancel,
	sendEmailTicketRefund,
	sendEmailIssueTicket,
	sendEmailBookingAdd
};

export default service;
